import type { AbstractControl } from '@angular/forms';

/**
 * The earliest invalid step before `before`, or null when everything up to it is filled in.
 *
 * Keyed off the step number in the key rather than the position, so it works whichever step a
 * Sparte's `allFgs` starts at — kfz begins at step1, hausrat at step2 (its step1 is a CTA screen
 * with no form).
 */
export const firstInvalidStep = (
  allFgs: Record<string, AbstractControl>,
  before: number
): string | null => {
  for (const [key, fg] of Object.entries(allFgs)) {
    if (Number(key.replace('step', '')) >= before) break;
    if (fg.invalid) return key;
  }

  return null;
};
